import { useState } from 'react'
import { Alert, Button, Container, Form, Spinner } from 'react-bootstrap'
import { useMutation } from 'react-query';
import apiClient from '../api';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function ResetPassword() {
	const [newPassword, setNewPassword] = useState("")
	const [confirmPassword, setConfirmPassword] = useState("");
	const [message, setMessage] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null);

	const {resetToken} = useParams();

	const mutation = useMutation(
		async (body:{newPassword: string, resetToken: string}) => {
		  const response = await apiClient.post("/auth/reset-password", body);
		  return response.data;
		},
		{
		  onSuccess: (data: any) => {
			setMessage(data?.message || "Password reset successful");
			setError(null);
		  },
		  onError: (error: any) => {
			setMessage(null);
			setError("Something went wrong. Please try again or contact admin.");
		  },
		}
	  );

	const handleSubmit = (e: { preventDefault: () => void; }) => {
		e.preventDefault();
		if(!newPassword || !confirmPassword) {
			setError("Please fill in all required fields");
			return
		}
		if(newPassword !== confirmPassword) {
			setError("Passwords do not match");
			return
		}
		if(!resetToken) {
			setError("Invalid reset token");
			return
		}
		mutation.mutate({newPassword, resetToken});
		
	}
	
  return (
	<Container className="mt-5"  style={{ maxWidth: '500px' }}>
		<Helmet>
			<title>Reset Password - QuickyChat</title>
			<meta name="description" content="Reset your password for QuickyChat. Enter your new password and confirm it to reset your account password." />
		</Helmet>
		<h3 className="text-center mb-4">Reset Password</h3>
		<Form onSubmit={handleSubmit}>
			<Form.Group controlId="organization" className="mb-3">
				<Form.Label>New Password*</Form.Label>
				<Form.Control 
					type="password" 
					value={newPassword} 
					placeholder='Enter new password' 
					onChange={e => setNewPassword(e.target.value)} 
					required/>
			</Form.Group>
			<Form.Group controlId="organization" className="mb-3">
				<Form.Label>Confirm Password*</Form.Label>
				<Form.Control 
					type="password" 
					value={confirmPassword} 
					placeholder='Confirm new password' 
					onChange={e => setConfirmPassword(e.target.value)} 
					required/>
			</Form.Group>
			{message && <Alert variant="success">{message}</Alert>}
			{error && <Alert variant="danger">{error}</Alert>}
			<Button type="submit" variant='outline-light'> 
				{mutation.isLoading && <Spinner/>} Update Password
			</Button>
		</Form>
	</Container>
  )
}

export default ResetPassword